/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { createDistance } from '../../factoriesAny.js';
export var distanceDependencies = {
  absDependencies: absDependencies,
  addScalarDependencies: addScalarDependencies,
  divideScalarDependencies: divideScalarDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  sqrtDependencies: sqrtDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  createDistance: createDistance
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDistance.generated.js
// module id = 1529
// module chunks = 0